module.exports = ".current-scenario{\r\n    text-align: center;\r\n}\r\n.divider {\r\n    clear: both;\r\n}\r\n.divider-space {\r\n    margin-bottom: 20px;\r\n}\r\n.merge-column {\r\n    float: left;\r\n    margin-right: 100px;\r\n}\r\n.section-title {\r\n    font-weight: bold;\r\n}\r\n.btn-right {\r\n    float: right;\r\n    margin-left: 15px;\r\n}\r\n\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./app/airports/airport.css
 ** module id = 775
 ** module chunks = 0
 **/